module.exports = __webpack_public_path__ + "ci_vendor_kapacitor.e62a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_kapacitor.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_kapacitor.svg
// module chunks = main